import "./NewReservation.scss"
import { useDispatch, useSelector } from "react-redux"
import { TextField, Button, Typography } from "@mui/material"
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"

import { RootState } from "../../redux/store"
import {
  updateReservationDates,
  updateReservationHours,
} from "../../redux/slices/newReservationSlice"
import VehiclesList from "../../components/ui/VehiclesList/VehiclesList.component"
import { useTranslationLabel } from "../../hooks/useTranslationLabel"
import DropdownSelect from "../../components/DropdownSelect/DropdownSelect.component"
import { useState } from "react"
import { CategoryItem, useGenerateCategories } from "../../utils/utils"

const NewReservation = () => {
  const dispatch = useDispatch()
  const { startDate, endDate, startHour, endHour } = useSelector(
    (state: RootState) => state.newReservation,
  )
  const categories: CategoryItem[] = useGenerateCategories()
  const { INPUT_START_DATE, INPUT_END_DATE, INPUT_START_HOUR, INPUT_END_HOUR } =
    useTranslationLabel()
  const [selectedMonth, setSelectedMonth] = useState("")

  // Handler for the date and hour change
  const handleDateChange = (newValue: any, field: any) => {
    dispatch(updateReservationDates({ field, value: newValue }))
  }

  const handleHourChange = (event: any, field: any) => {
    dispatch(updateReservationHours({ field, value: event.target.value }))
  }

  // Submit handler for the form
  const handleSubmit = () => {
    // Implement submission logic here
    console.log("Submitting new reservation:", {
      startDate,
      endDate,
      startHour,
      endHour,
    })
  }

  return (
    <div className="new-reservation-container column">
      <div className="toolbar ">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <div className="full space-between center">
            <div className="column">
              <Typography className="body1">{INPUT_START_DATE}</Typography>
              <DatePicker
                value={startDate}
                onChange={(newValue) => handleDateChange(newValue, "startDate")}
              />
            </div>
            <div className="column">
              <Typography className="body1">{INPUT_START_HOUR}</Typography>
              <TextField
                type="time"
                value={startHour}
                onChange={(event) => handleHourChange(event, "startHour")}
              />
            </div>
            <div className="column">
              <Typography className="body1">{INPUT_END_DATE}</Typography>
              <DatePicker
                value={endDate}
                onChange={(newValue) => handleDateChange(newValue, "endDate")}
              />
            </div>
            <div className="column">
              <Typography className="body1">{INPUT_END_HOUR}</Typography>
              <TextField
                type="time"
                value={endHour}
                onChange={(event) => handleHourChange(event, "endHour")}
              />
            </div>
          </div>
          <DropdownSelect
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
            items={categories}
            // startIcon={calenderIcon}
          />
          <Button variant="contained" onClick={handleSubmit}>
            Submit
          </Button>
        </LocalizationProvider>
      </div>
      <VehiclesList></VehiclesList>
    </div>
  )
}

export default NewReservation
